const testQuestionDescription = (questionDesc) => {
  function replaceAll(string, search, replace) {
    return string.split(search).join(replace);
  }
  if (questionDesc) {
    const codeWithJsx = "<pre class='line-numbers language-js'}><code className={`language-js`}>";
    const codeSlasWithJsx = "</code></pre>";
    let str = questionDesc;
    str = replaceAll(str, '<code>', codeWithJsx);
    str = replaceAll(str, '</code>', codeSlasWithJsx);
    str = replaceAll(str, '<pre class="ql-syntax" spellcheck="false">', codeWithJsx);
    str = replaceAll(str, '</pre>', codeSlasWithJsx);
    let questionText = <p className='without-line-break' dangerouslySetInnerHTML={{
      __html: str
    }}></p>
    return questionText
  }
}
export default testQuestionDescription;